module.exports = __webpack_public_path__ + "img/yellow-tick.0b7f072e.png";